import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { CompaniesFilter, CountryFilter } from './common.filter'

const getIntroducingBrokerClientsField = (): FieldSettings[] => [
  {
    name: 'Username',
    label: 'Username',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: 'Country',
    label: 'Country',
    filter: CountryFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: 'Name',
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.likeOperator,
        operator: GridFilterOperatorEnum.likeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notLikeOperator,
        operator: GridFilterOperatorEnum.notLikeOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notStartsWithOperator,
        operator: GridFilterOperatorEnum.notStartsWithOperator,
      },
    ],
  },
  {
    name: 'TickmillCompanyId',
    label: 'Company',
    filter: CompaniesFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]

export { getIntroducingBrokerClientsField }
